module.exports = __webpack_public_path__ + "img/nor_py_moun1.eab84564.png";